import Api from '../_redux/actions/api/_base';
import moment from 'moment';
import cookie from 'react-cookies';

export const handleVivoSubmit = async (Address, Subscription, VivoData) => {
	const token = cookie.load('token');
	/*const mockEpayData = {
		status: 'success',
		message: 'Code available to be redeemed',
		giftCode: {
			code: '9234567899900007853',
			id: '3',
			status: 'ACTIVATED',
			value: '179.70'
		},
		plan: {
			id: '11',
			signatureType: 'saude',
			value: '179.70',
			name: 'YALO Saúde Trimestral'
		}
	};*/
	const SubscriptionInfo = Subscription.data.itens[0];
	const areaCode = SubscriptionInfo?.phone.split(' ')[0];
	const number = SubscriptionInfo?.phone.split(' ')[1];
	SubscriptionInfo.cpf = SubscriptionInfo.cpf.replace(/\D+/g, '');
	SubscriptionInfo.phone = {
		areaCode,
		number
	};
	const orderId = SubscriptionInfo.orderId;
	const phoneNumber = VivoData.phone;

	const data = {
		orderId,
		phoneNumber,
	};

	let hasError = '';
	//	return (hasError = false); //mock

	const response = await Api.post('/vivo/redeem', data, token);

	if (response.status === 200) {
		//dispatch(successNumberContact(userNumberResponse.data)); //	TODO VERIFICAR A RESPOSTA DO BACKEND QUANDO FOR 200

		hasError = false;
	} else {
		hasError = 'true1';
	}
	return hasError;


};
